// extracted by mini-css-extract-plugin
module.exports = {"qrReader":"QrScanner_qrReader__OSuEB"};